"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUser = void 0;
const enums_1 = require("../../enums");
const validateUser = (user) => {
    var _a, _b;
    let missing = [];
    if (!user)
        missing.push(enums_1.OrderValidation.MissingUser);
    if (!(user === null || user === void 0 ? void 0 : user.departmentId))
        missing.push(enums_1.OrderValidation.MissingUserDefaultDepartmentId);
    if (!(user === null || user === void 0 ? void 0 : user.reference))
        missing.push(enums_1.OrderValidation.MissingUserReference);
    if (!((_a = user === null || user === void 0 ? void 0 : user.reference) === null || _a === void 0 ? void 0 : _a.bosApiId))
        missing.push(enums_1.OrderValidation.MissingUserReferenceBosApiId);
    if (!((_b = user === null || user === void 0 ? void 0 : user.reference) === null || _b === void 0 ? void 0 : _b.santanderId))
        missing.push(enums_1.OrderValidation.MissingUserReferenceSantanderId);
    return Array.from(new Set(missing));
};
exports.validateUser = validateUser;
//# sourceMappingURL=user.js.map